<template>
    <div>
        <admin-employee-hourly-annual-leave-list></admin-employee-hourly-annual-leave-list>
    </div>
    </template>
    <script>
    export default {}
    </script>
    